import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ca8e864"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "IDESideBarContentTabFileSystem" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "filesTree" }

import { ref, withDefaults, watch } from 'vue';
import * as IDESideBarContentTabFileSystemTree from './IDESideBarContentTabFileSystemTree.vue';

export interface PropsOptions {
	workspaces: Array<Workspace>,
}



export enum FSEntryType {
	directory = "directory",
	file = "file",
}

export interface IFSEntryConstructor {
	filename: string,
}
export class FSEntry {
	type: FSEntryType;
	filename: string;

	constructor(type:FSEntryType, {filename} : IFSEntryConstructor) {
		this.type = type;
		this.filename = filename;
	}

	getBasename() {
		const parts = this.filename.split('/');
		return parts[parts.length - 1];
	}
}

export interface IFSEntryDirectoryConstructor extends IFSEntryConstructor {
	expanded: boolean,
	subtree?: FilesTree,
	parent?: FSEntryDirectory|null,
}
export class FSEntryDirectory extends FSEntry {
	expanded: boolean;
	subtree: FilesTree;
	parent: FSEntryDirectory|null = null;

	constructor({expanded, subtree, parent, ...argx} : IFSEntryDirectoryConstructor) {
		super(FSEntryType.directory, argx);
		this.expanded = expanded;
		this.subtree = subtree !== undefined ? subtree : new FilesTree({});
		this.parent = parent !== undefined ? parent : null;
	}

	getParent() {
		return this.parent;
	}

	static GetEntriesDiff(currentEntries:Array<FSEntry>, newItemsNames: Array<string>) {
		const currentNames = currentEntries.map((entry) => entry.getBasename());
		// zjistit, ktere slozky pribyly
		const itemsToAdd = newItemsNames.filter((v:string) => !currentNames.includes(v));
		// zjistit, ktere slozky zmizely
		const itemsToRemove = currentNames.filter((v:string) => !newItemsNames.includes(v));
		return {
			itemsToAdd,
			itemsToRemove,
		};
	}

	setDirectories(entriesNames: Array<string>) {
		const entriesDiff = FSEntryDirectory.GetEntriesDiff(this.subtree.directories, entriesNames);
		// odstranit polozky co nejsou v novem seznamu
		this.subtree.directories = this.subtree.directories.filter((entry) => !entriesDiff.itemsToRemove.includes(entry.getBasename()));
		// pridat nove polozky
		for (const name of entriesDiff.itemsToAdd) {
			this.subtree.directories.push(new FSEntryDirectory({filename: `${this.filename}/${name}`, expanded: false, parent: this}));
		}
	}

	setFiles(entriesNames: Array<string>) {
		const entriesDiff = FSEntryDirectory.GetEntriesDiff(this.subtree.files, entriesNames);
		// odstranit polozky co nejsou v novem seznamu
		this.subtree.files = this.subtree.files.filter((entry) => !entriesDiff.itemsToRemove.includes(entry.getBasename()));
		// pridat nove polozky
		for (const name of entriesDiff.itemsToAdd) {
			this.subtree.files.push(new FSEntryFile({filename: `${this.filename}/${name}`}));
		}
	}

	setContent({directories, files} : {directories: Array<string>, files: Array<string>}) {
		this.setDirectories(directories);
		this.setFiles(files);
	}

	*getAllDirectories() : Generator<FSEntryDirectory> {
		for (const entry of this.subtree.directories) {
			yield entry;
			for (const subentry of entry.getAllDirectories()) {
				yield subentry;
			}
		}
	}

	*getAllFiles() : Generator<FSEntryFile> {
		for (const entry of this.subtree.files) {
			yield entry;
		}
		for (const entry of this.subtree.directories) {
			for (const subentry of entry.getAllFiles()) {
				yield subentry;
			}
		}
	}
}

export interface IFSEntryFileConstructor extends IFSEntryConstructor {
	active?: boolean,
	openInEditor?: boolean,
	openByLector?: boolean,
	isLectorActive?: boolean,
}
export class FSEntryFile extends FSEntry {
	active: boolean;
	openInEditor: boolean;
	openByLector: boolean;
	isLectorActive: boolean;

	constructor({active, openInEditor, openByLector, isLectorActive, ...argx} : IFSEntryFileConstructor) {
		super(FSEntryType.file, argx);
		this.active = active !== undefined ? active : false;
		this.openInEditor = openInEditor !== undefined ? openInEditor : false;
		this.openByLector = openByLector !== undefined ? openByLector : false;
		this.isLectorActive = isLectorActive !== undefined ? isLectorActive : false;
	}
}

export type FSEntryByType = {
	[FSEntryType.directory]: FSEntryDirectory;
	[FSEntryType.file]: FSEntryFile;
}

export class FilesTree {
	directories: Array<FSEntryDirectory>;
	files: Array<FSEntryFile>;

	constructor({directories, files} : {directories?: Array<FSEntryDirectory>, files?: Array<FSEntryFile>}) {
		this.directories = directories !== undefined ? directories : [];
		this.files = files !== undefined ? files : [];
	}
}

export class Workspace {
	rootDirectory: FSEntryDirectory;

	constructor(dirname:string) {
		this.rootDirectory = new FSEntryDirectory({filename: dirname, expanded: true});
	}

	getDirname() {
		return this.rootDirectory.filename;
	}

	getTitle() {
		const parts = this.getDirname().split('/');
		return parts[parts.length - 1];
	}

	getNormalizedDirname() {
		const dirname = this.getDirname();
		return dirname.endsWith('/') ? dirname : dirname + '/';
	}

	matchesDirectory(dirname:string) {
		return dirname == this.getDirname() || dirname.startsWith(this.getNormalizedDirname());
	}

	getDirectoryByDirname(dirname:string) {
		if (!this.matchesDirectory(dirname)) {
			throw new Error("Given file is out of this workspace");
		}
		for (const directory of this.getAllDirectories()) {
			if (directory.filename == dirname) {
				return directory;
			}
		}
		return null;
	}

	getTopMostDirectoryByDirname(dirname:string) {
		if (!this.matchesDirectory(dirname)) {
			throw new Error("Given file is out of this workspace");
		}
		let bestDirectory = null;
		for (const directory of this.getAllDirectories()) {
			if (dirname.startsWith(directory.filename)) {
				if (bestDirectory == null || directory.filename.length > bestDirectory.filename.length) {
					bestDirectory = directory;
				}
			}
		}
		return bestDirectory;
	}

	*getAllDirectories() {
		yield this.rootDirectory;
		yield * this.rootDirectory.getAllDirectories();
	}

	*getAllFiles() {
		yield * this.rootDirectory.getAllFiles();
	}
}

export const EmitsOptions = {
	'onClickFile' : (fileEntry: FSEntryFile) => {return true;},
	'onClickDirectory' : (directoryEntry: FSEntryDirectory) => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDESideBarContentTabFileSystem',
  props: {
    workspaces: { default() {
		return [];
	} }
  },
  emits: EmitsOptions,
  setup(__props: any, { emit }) {

const props = __props as { workspaces: Array<Workspace> }






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspaces, (workspace) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "workspace",
        key: workspace.getNormalizedDirname()
      }, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(workspace.getTitle()), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(IDESideBarContentTabFileSystemTree.default, {
            filesTree: workspace.rootDirectory.subtree,
            level: 0,
            onOnClickDirectory: _cache[0] || (_cache[0] = (...args) => emit('onClickDirectory', ...args)),
            onOnClickFile: _cache[1] || (_cache[1] = (...args) => emit('onClickFile', ...args))
          }, null, 8, ["filesTree"])
        ])
      ]))
    }), 128))
  ]))
}
}

})